import React from 'react';
import ServicesStack from '../components/ServicesStack';
import TestimonialsSlider from '../components/TestimonialsSlider';
import CTASection from '../components/CTASection';
import IdealistaSection from '../components/IdealistaSection';
import ServicesMarquee from '../components/ServicesMarquee';
import SEOMetaTags from '../components/SEOMetaTags';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';

const Home = () => {
    const { t } = useLanguage();
    usePageTitle('home');

    return (
        <div className="inner-page-content">
            <SEOMetaTags pageKey="home" />
            {/* Hero Section Start */}
            <div className="mxd-section mxd-section-inner-headline padding-text-pre-block">
                <div className="mxd-container grid-container">
                    <div className="mxd-block loading-wrap">
                        <div className="container-fluid px-0">
                            <div className="row gx-0">
                                <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                    <div className="mxd-block__name name-inner-headline loading__item">
                                        <p className="mxd-point-subtitle">
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill="currentColor" d="M19.6,9.6c0,0-3,0-4,0c-0.4,0-1.8-0.2-1.8-0.2c-0.6-0.1-1.1-0.2-1.6-0.6c-0.5-0.3-0.9-0.8-1.2-1.2
                          c-0.3-0.4-0.4-0.9-0.5-1.4c0,0-0.1-1.1-0.2-1.5c-0.1-1.1,0-4.4,0-4.4C10.4,0.2,10.2,0,10,0S9.6,0.2,9.6,0.4c0,0,0.1,3.3,0,4.4
                          c0,0.4-0.2,1.5-0.2,1.5C9.4,6.7,9.2,7.2,9,7.6C8.7,8.1,8.2,8.5,7.8,8.9c-0.5,0.3-1,0.5-1.6,0.6c0,0-1.2,0.1-1.7,0.2
                          c-1,0.1-4.2,0-4.2,0C0.2,9.6,0,9.8,0,10c0,0.2,0.2,0.4,0.4,0.4c0,0,3.1-0.1,4.2,0c0.4,0,1.7,0.2,1.7,0.2c0.6,0.1,1.1,0.2,1.6,0.6
                          c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.5,0.5,1,0.6,1.6c0,0,0.1,1.3,0.2,1.7c0,1,0,4.1,0,4.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4
                          c0,0,0-3.1,0-4.1c0-0.4,0.2-1.7,0.2-1.7c0.1-0.6,0.2-1.1,0.6-1.6c0.3-0.4,0.7-0.8,1.1-1.1c0.5-0.3,1-0.5,1.6-0.6
                          c0,0,1.3-0.1,1.8-0.2c1,0,4,0,4,0c0.2,0,0.4-0.2,0.4-0.4C20,9.8,19.8,9.6,19.6,9.6L19.6,9.6z"/>
                                            </svg>
                                            <span>{t('home.hero.brand_tag')}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-8 mxd-grid-item no-margin">
                                    <div className="mxd-block__content">
                                        <div className="mxd-block__inner-headline">
                                            <h1 className="inner-headline__title animated-type loading__item h1-small">
                                                <span id="typed-strings">
                                                    <b>{t('home.hero.title')}</b>
                                                    <b>{t('home.hero.subtitle')}</b>
                                                </span>
                                                <span id="typed"></span>
                                            </h1>
                                            <p className="inner-headline__text t-large t-bright loading__item">
                                                {t('home.hero.description')}
                                            </p>
                                            <div className="mxd-promo__controls anim-uni-in-up" style={{ marginTop: '40px' }}>
                                                <a
                                                    className="btn btn-anim btn-primary btn-large slide-right-up"
                                                    href="https://wa.me/34610683948"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span className="btn-caption">{t('home.hero.cta')}</span>
                                                    <i className="ph-bold ph-arrow-up-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Hero Section End */}


            {/* Idealista Section Start */}
            <IdealistaSection style={{ marginBottom: '7rem', marginTop: '7rem' }} />
            {/* Idealista Section End */}

            {/* Testimonios Section Start */}
            <TestimonialsSlider
                testimonials={[
                    {
                        name: t('testimonials.laura.name'),
                        position: t('testimonials.laura.position'),
                        text: t('testimonials.laura.text'),
                        avatar: null,
                        image: null,
                        rating: 5,
                        buttonText: t('testimonials.laura.button'),
                        buttonLink: "#"
                    },
                    {
                        name: t('testimonials.carlos.name'),
                        position: t('testimonials.carlos.position'),
                        text: t('testimonials.carlos.text'),
                        avatar: null,
                        image: null,
                        rating: 5,
                        buttonText: t('testimonials.carlos.button'),
                        buttonLink: "#"
                    },
                    {
                        name: t('testimonials.ana.name'),
                        position: t('testimonials.ana.position'),
                        text: t('testimonials.ana.text'),
                        avatar: null,
                        image: null,
                        rating: 5,
                        buttonText: t('testimonials.ana.button'),
                        buttonLink: "#"
                    }
                ]}
                variant="photo"
            />
            {/* Testimonios Section End */}



            {/* Servicios Section Start */}
            <div className="mxd-section padding-pre-grid">
                <div className="mxd-container grid-container">
                    <div className="mxd-block">
                        <div className="mxd-section-title">
                            <div className="container-fluid p-0">
                                <div className="row g-0">
                                    <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                        <div className="mxd-section-title__hrtitle">
                                            <h2 className="reveal-type">{t('home.services.title')}</h2>
                                        </div>
                                    </div>
                                    <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                        <div className="mxd-section-title__hrdescr">
                                            <p className="anim-uni-in-up">
                                                {t('home.services.description')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ServicesStack services={[
                            {
                                title: t('home.services.transparency.title'),
                                number: "01",
                                description: t('home.services.transparency.description'),
                                backgroundColor: "bg-primary",
                                titleClass: "text-tertiary",
                                descriptionClass: "text-tertiary"
                            },
                            {
                                title: t('home.services.responsibility.title'),
                                number: "02",
                                description: t('home.services.responsibility.description'),
                                backgroundColor: "bg-secondary",
                                titleClass: "text-tertiary",
                                descriptionClass: "text-tertiary"
                            },
                            {
                                title: t('home.services.optimization.title'),
                                number: "03",
                                description: t('home.services.optimization.description'),
                                backgroundColor: "bg-tertiary",
                                titleClass: "text-primary",
                                descriptionClass: "text-secondary"
                            },
                            {
                                title: t('home.services.customer_focused.title'),
                                number: "04",
                                description: t('home.services.customer_focused.description'),
                                backgroundColor: "bg-primary",
                                titleClass: "text-tertiary",
                                descriptionClass: "text-tertiary"
                            }
                        ]} />
                    </div>
                </div>
            </div>
            {/* Servicios Section End */}

            {/* Services Marquee */}
            <ServicesMarquee />
            {/* Services Marquee End */}

            {/* Sobre Nosotros Section Start */}
            <div className="mxd-section padding-pre-grid">
                <div className="mxd-container grid-container">
                    <div className="mxd-block">
                        <div className="mxd-section-title">
                            <div className="container-fluid p-0">
                                <div className="row g-0">
                                    <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                        <div className="mxd-section-title__hrtitle">
                                            <h2 className="reveal-type">{t('home.about.title')}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mxd-approach-list">
                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt={t('common.alt_texts.mission')} />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>{t('home.about.mission.title')}</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>{t('home.about.mission.description')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>

                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt={t('common.alt_texts.vision')} />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>{t('home.about.vision.title')}</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>{t('home.about.vision.description')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>

                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt={t('common.alt_texts.international')} />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>{t('home.about.international.title')}</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>{t('home.about.international.description')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>

                            <div className="mxd-approach-list__item">
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                                <div className="mxd-approach-list__inner">
                                    <div className="container-fluid px-0">
                                        <div className="row gx-0">
                                            <div className="col-12 col-xl-2 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__image anim-uni-in-up">
                                                    {/*<img src="https://dummyimage.com/100x100/4d4d4d/838383" alt={t('common.alt_texts.team')} />*/}
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-4 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__title anim-uni-in-up">
                                                    <h6>{t('home.about.team.title')}</h6>
                                                </div>
                                            </div>
                                            <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                                <div className="mxd-approach-list__descr anim-uni-in-up">
                                                    <p>{t('home.about.team.description')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-approach-list__border anim-uni-in-up"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Sobre Nosotros Section End */}

            {/* CTA Final Section Start */}
            <CTASection
                title={t('home.cta.title')}
                description={t('home.cta.description')}
                buttonText={t('home.cta.button')}
                icon="/img/icons/300x300_obj-cta-01.webp"
                iconType="image"
            />
            {/* CTA Final Section End */}
        </div>
    );
};

export default Home;
